import { GallerySearchMode } from '../models/gallery-search-mode.enum';
import { StudioOptionsModel } from '../models/studio-options.model';
import { GalleryViewMode } from '../models/gallery-view-mode.enum';
import { ListValue } from 'src/app/modules/modules.service';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';
import { BookmarkSortModel } from 'src/app/bookmarks/models/bookmark-sort.model';
import { SearchConfigUnion, LoftSearchConfig } from '../models/search-config';
import { SearchOptions } from '../models/search-options';
import { GallerySidenav, GalleryCardActions, GalleryBulkActions } from './gallery.state.model';

export namespace GalleryActions {
  export class SetSearchMode {
    static readonly type = '[Gallery] Set Search Mode';
    constructor(public searchMode: GallerySearchMode) {}
  }

  export class SetViewMode {
    static readonly type = '[Gallery] Set View Mode';
    constructor(public viewMode: GalleryViewMode) {}
  }

  export class SetSort {
    static readonly type = '[Gallery] Set Sort';
    constructor(public sort: BookmarkSortModel) {}
  }

  export class GetStudioOptions {
    static readonly type = '[Gallery] Get Studio Options';
    constructor(public organizationId?: number) {}
  }

  export class GetStudioOptionsSuccess {
    static readonly type = '[Gallery] Get Studio Options Success';
    constructor(public options: StudioOptionsModel[]) {}
  }

  export class SearchLoft {
    static readonly type = '[Gallery] Search Loft';
    constructor(public config: LoftSearchConfig) {}
  }

  export class SearchLoftSuccess {
    static readonly type = '[Gallery] Search Loft Success';
    constructor(public bookmarks: ListValue[]) {}
  }

  // Types of searches
  // - Studio
  // -- Internal: categoryId?: string
  // -- Organization: organizationId: string, collectionId?: string
  // - Loft
  // -- Internal: categoryId?: string
  // -- Client: ??
  //
  // SetSearchConfig and SearchStudio are isolated actions. Since there are multiple
  // components which can "trigger" a search, the core responsibility of dispatching the real
  // search is handled by the root GalleryContainer component.
  export class SetSearchConfig {
    static readonly type = '[Gallery] Set Search Config';
    constructor(public config: SearchConfigUnion, public options?: SearchOptions) {}
  }

  export class SetSearchOptions {
    static readonly type = '[Gallery] Set Search Options';
    constructor(public options: SearchOptions) {}
  }

  export class SearchStudio {
    static readonly type = '[Gallery] Search Studio';
    constructor() {}
  }
  export class SearchStudioSuccess {
    static readonly type = '[Gallery] Search Studio Success';
    constructor(public bookmarks: BookmarkModel[]) {}
  }

  export class SearchSuccess {
    static readonly type = '[Gallery] Search Success';
    constructor(public bookmarks: BookmarkModel[]) {}
  }

  export class SelectBookmark {
    static readonly type = '[Gallery] Select Bookmark';
    constructor(public result: BookmarkModel) {}
  }

  export class SetSidenav {
    static readonly type = '[Gallery] Set Sidenav';
    constructor(public sidenav: GallerySidenav) {}
  }

  export class SetBulkActions {
    static readonly type = '[Gallery] Set Bulk Actions';
    constructor(public bulkActions: GalleryBulkActions) {}
  }

  export class SetCardActions {
    static readonly type = '[Gallery] Set Card Actions';
    constructor(public cardActions: GalleryCardActions) {}
  }

  export class ClearResults {
    static readonly type = '[Gallery] Clear Results';
    constructor() {}
  }

  export class CheckItem {
    static readonly type = '[Gallery] Check Item';
    constructor(public id: string, public checked?: boolean) {}
  }

  export class CheckAll {
    static readonly type = '[Gallery] Check All';
    constructor() {}
  }

  export class UncheckAll {
    static readonly type = '[Gallery] Uncheck All';
    constructor() {}
  }

  export class SetCheckedItems {
    static readonly type = '[Gallery] Set Checked Items';
    constructor(public ids: string[]) {}
  }

  export class Reset {
    static readonly type = '[Gallery] Reset';
    constructor() {}
  }
}
